<template>
    <v-dialog
        v-model="$props.params.templateDialog"
        :persistent="showProgressBar"
        max-width="600px"
        transition="dialog-bottom-transition"
        @keydown.esc="!showProgressBar ? closeTemplateDialog() : ''"
        @click:outside="!showProgressBar ? closeTemplateDialog() : ''"
    >
        <v-card>
            <v-form @submit.prevent="processLoadTemplate()">
                <v-toolbar
                    :class="dialogHeadingClasses()"
                    color="primary"
                    dark
                >
                    <v-icon class="mr-3" v-text="icons.mdiRestore"></v-icon>
                    {{ $gettext('Load a Template') }}
                    <v-spacer></v-spacer>
                    <v-icon v-show="!showProgressBar" class="mr-2" v-text="icons.mdiClose"
                            @click.native.stop="closeTemplateDialog()"></v-icon>
                    <!--                    <v-icon @click.native.stop="processLoadTemplate()" v-text="icons.mdiContentSave" v-show="!showProgressBar"></v-icon>-->
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-text class="mt-4">
                    <v-container>

                        <v-row v-if="showProgressBar">
                            <v-col>
                                <progress-bar :text="templateProgressBarMessage"></progress-bar>
                            </v-col>
                        </v-row>

                        <v-row v-else>
                            <v-col>

                                <!--<v-autocomplete
                                    v-model="chosenTemplate"
                                    :error-messages="chosenTemplateErrors"
                                    :items="allTemplates"
                                    :label="$gettext('Please pick a template')"
                                    :no-data-text="$gettext('Sorry, we don\'t seem to have any templates as of now.')"
                                    outlined
                                    @blur="$v.chosenTemplate.$touch()"
                                    @change="resetTemplateLoadConfirmation()"
                                    @input="$v.chosenTemplate.$touch()"
                                >
                                </v-autocomplete>-->

                                <v-autocomplete
                                    v-model="chosenTemplate"
                                    :error-messages="chosenTemplateErrors"
                                    :items="centralisedTemplates"
                                    :label="$gettext('Please pick a template')"
                                    :no-data-text="$gettext('Sorry, we don\'t seem to have any templates as of now.')"
                                    outlined
                                    @blur="$v.chosenTemplate.$touch()"
                                    @change="resetTemplateLoadConfirmation()"
                                    @input="$v.chosenTemplate.$touch()"
                                >
                                </v-autocomplete>

                                <v-checkbox
                                    v-if="chosenTemplate"
                                    v-model="templateLoadConfirmation"
                                    :error-messages="templateLoadConfirmationErrors"
                                    :false-value="false"
                                    :true-value="true"
                                    @blur="$v.templateLoadConfirmation.$touch()"
                                    @input="$v.templateLoadConfirmation.$touch()"
                                >
                                    <template v-slot:label>
                                        <div v-text="$gettextInterpolate($gettext('I want to load the %{ chosenTemplate } configuration.'), { 'chosenTemplate':
                                            chosenTemplate.replace('.zip', '')})"></div>
                                    </template>
                                </v-checkbox>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider></v-divider>

                <v-card-actions v-show="!showProgressBar" color="secondary">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click.native.stop="closeTemplateDialog()">
                        {{ $gettext('Close') }}
                    </v-btn>
                    <v-btn color="primary" type="submit">
                        {{ $gettext('Load Template') }}
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <snackbar ref="snackbar"></snackbar>

    </v-dialog>
</template>
<style type="text/scss">
.add-rule-radio-margin .v-input--selection-controls {
    margin-top: 0;
}

</style>

<script>

import Vue from 'vue'
import {find, findIndex, size} from 'lodash'

import Vuelidate from 'vuelidate'
import {required, minLength, maxLength, between, sameAs} from 'vuelidate/lib/validators'

import MixinDialog from '@/mixins/MixinDialog'
import MixinIcon from '@/mixins/MixinIcon'
import Snackbar from '@/components/Snackbar'
import MixinStringManipulation from '@/mixins/MixinStringManipulation'
import MixinConfigRules from '@/mixins/database/MixinConfigRules'
import MixinLodashPadStart from '@/mixins/lodash/MixinLodashPadStart'
import {mapState, mapWritableState} from 'pinia'
import {useConnectionsStore} from '@/stores/ConnectionsStore'
import {useProgressBarsStore} from '@/stores/ProgressBarStore'
import {useRulesStore} from '@/stores/RulesStore'
import {useGroupsStore} from '@/stores/GroupsStore'
import {useCategoriesStore} from '@/stores/CategoriesStore'
import MixinConfig from '@/mixins/database/MixinConfig'
import MixinGenericComponent from '@/mixins/generic/MixinGenericComponent'
import ProgressBar from '@/components/ProgressBar'
import MixinTemplate from '@/mixins/MixinTemplate'
import MixinSwalConfirmation from '@/mixins/swal/MixinSwalConfirmation'
import {useCentralisedTemplatesStore} from "@/stores/CentralisedTemplatesStore";

Vue.use(Vuelidate)

export default {
    components: {Snackbar, ProgressBar},
    mixins: [MixinConfig, MixinDialog, MixinIcon, MixinStringManipulation, MixinConfigRules, MixinLodashPadStart, MixinTemplate, MixinGenericComponent, MixinSwalConfirmation],
    props: {
        params: {
            required: true,
            type: Object | Array,
        },
    },
    mounted() {

        let self = this

        /*
        self.showProgressBar = true

        self.templateLoadAllTemplates().then((response) => {

            if (response.status) {

                let at = response.data.templates

                if (at && at.length > 0) {
                    self.allTemplates = typeof at === 'string' ? JSON.parse(at) : (typeof at === 'object' ? at : [])
                }

            }

        }).catch((error) => {
            // TODO: Handle this
            console.log(error)
        }).finally(() => {
            self.showProgressBar = false
        })

         */

    },
    data() {
        return {
            templateProgressBarMessage: 'Just a moment...',
            showProgressBar: false,
            allTemplates: [],
            allTemplatesFromCentralisedSftp: [],
            chosenTemplate: '',
            templateLoadConfirmation: false,
        }
    },

    methods: {

        resetTemplateLoadConfirmation() {
            this.templateLoadConfirmation = false
        },

        processLoadTemplate() {

            let self = this

            self.$v.$touch()

            if (!self.$v.$invalid) {

                self.showProgressBar = true
                self.templateProgressBarMessage = 'Loading template...'

                self.templateProcessLoadTemplate(self.chosenTemplate).then((response) => {

                    if (response.status) {

                        if (response.data.hasOwnProperty('loadTemplateDetails') && response.data.loadTemplateDetails) {

                            if (typeof response.data.loadTemplateDetails === 'string') {
                                response.data.loadTemplateDetails = JSON.parse(response.data.loadTemplateDetails)
                            }

                            self.configSetVariablesToStores(response.data.loadTemplateDetails, false, false, 'template')
                            let appComponent = self.genericComponentGetComponent('App')
                            appComponent.$refs.snackbar.showSnackbar(self.$gettext('Template loaded successfully! Please don\'t forget to save.'))
                            self.resetForm()
                            self.closeTemplateDialog()

                        }

                    }

                }).catch((error) => {

                    // FIXME: REMOVE THIS
                    console.log('error', error)

                }).finally(() => {
                    self.showProgressBar = false
                    self.templateProgressBarMessage = ''
                    // self.closeTemplateDialog();
                })

            }

        },
        closeTemplateDialog() {
            let self = this
            let appComponent = self.genericComponentGetComponent('App')
            appComponent.closeDialog('templateDialog')
        },
        resetForm() {
            let self = this
            self.$v.$reset()
            self.chosenTemplate = ''
        },
    },
    computed: {

        ...mapState(useConnectionsStore, {
            currentConnection: 'currentConnection',
        }),

        ...mapWritableState(useProgressBarsStore, {
            progressBars: 'progressBars',
        }),

        ...mapWritableState(useRulesStore, {
            rules: 'rules',
        }),
        ...mapWritableState(useGroupsStore, {
            groups: 'groups',
        }),

        ...mapWritableState(useCategoriesStore, {
            categories: 'categories',
            whitelist: 'whitelist',
            blacklist: 'blacklist'
        }),

        chosenTemplateErrors() {
            let self = this
            let errors = []
            if (!self.$v.chosenTemplate.$dirty) return errors
            !self.$v.chosenTemplate.required && errors.push(this.$gettext('Please choose a template'))
            return errors
        },

        templateLoadConfirmationErrors() {
            let self = this
            let errors = []
            if (!self.$v.templateLoadConfirmation.$dirty) return errors
            !self.$v.templateLoadConfirmation.sameAs && errors.push(this.$gettext('Please confirm.'))
            return errors
        },

        ...mapState(useCentralisedTemplatesStore, {
            centralisedTemplates: 'centralisedTemplates',
        }),

    },
    validations: {
        chosenTemplate: {
            required,
        },
        templateLoadConfirmation: {
            sameAs: sameAs(() => true)
        },
    },
}
</script>
